<script>
import { useMenuStore } from "@/store/menu";
import { mapState } from "pinia";

import { pageHomeEmits, pageHomeProps, usePageHome } from "./mixin";
import Carousel from "@/components/organisms/carousel";
import CarouselSlide from "@/components/organisms/carousel/carousel-slide";
import PushProductBlock from "@/components/organisms/push-products-block/mobile";
import CheckLad from "@/components/organisms/check-lad";
import Prospectus from "@/components/molecules/prospectus";
import Titre from "@/components/atoms/titre";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import ContainerHeading from "@/containers/container-heading";
import Divider from "@/components/atoms/divider";
import Container from "@/components/atoms/container";
import PlanningCommunesSelector from "@/containers/planning/planning-communes-selector";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Card from "@/components/molecules/card";
import Planning from "@/containers/planning";
import Alert from "@/components/molecules/alert";
import PageContenu from "@/components/pages/infos-et-services/page-contenu/mobile";
import Popin from "@/components/molecules/popin";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import WidgetPlanning from "@/containers/planning/widget-planning";
import HomeAchatExpressMobile from "@/components/organisms/home/achats-express";
import AbonnementRenouvellement from "@/components/organisms/abonnement-lad/panier/renouvellement/mobile";
import AbonnementLadBanniere from "@/containers/abonnement-lad/banner";
import ModeCommandeOverview from "@/components/organisms/mode-commande-overview/mobile";
import CmsFetcher from "@/containers/cms-fetcher";
import StoreAttachment from "@/components/organisms/store-attachment/default";
import LazyImage from "@/components/atoms/lazy-image";
import ContactInfoCorapro from "@/components/organisms/contact-infos-corapro/home";
import LinkTo from "@/components/atoms/link-to/link";
import {
  useAbonnementLadBanner,
  ABO_LAD_HOME_COOKIE_NAME
} from "@/composables/abonnement-lad";

import illustrationCarotteFromageLait from "@/assets/images/illustration-carotte-fromage-lait.svg";
import illustrationAnanasPastequePain from "@/assets/images/illustration-ananas-pasteque-pain.svg";
import illustrationAnanasPastequePlat from "@/assets/images/illustration-ananas-pasteque-plat.svg";
import banniereCorapro from "@/assets/images/banniere-corapro-devis-mobile.jpg";
import { useContextStore } from "@/store/context";

export default {
  name: "HomePage",
  components: {
    Carousel,
    Button,
    ButtonIcon,
    CarouselSlide,
    PushProductBlock,
    CheckLad,
    PlanningCommunesSelector,
    Prospectus,
    Container,
    ContainerHeading,
    Divider,
    GridRow,
    GridCol,
    Card,
    Planning,
    Alert,
    HtmlParser,
    Popin,
    WidgetPlanning,
    PageContenu,
    Titre,
    HomeAchatExpressMobile,
    AbonnementRenouvellement,
    AbonnementLadBanniere,
    ModeCommandeOverview,
    CmsFetcher,
    StoreAttachment,
    LazyImage,
    ContactInfoCorapro,
    LinkTo
  },
  emits: ["displayOrCloseStoreLocatorPopin", ...pageHomeEmits()],
  data() {
    return {
      cardsModesCommandeMiseEnAvant: [
        "LAD",
        "LC",
        "DRIVE",
        "PRP",
        "CC",
        "CEV",
        "PRC",
        "PRC_DELIPOP"
      ]
    };
  },
  computed: {
    ...mapState(useMenuStore, ["slugFaireMesCourses"])
  },
  props: {
    ...pageHomeProps()
  },
  setup(props, context) {
    const deliveryTermsPopin = ref(null);
    const { isClosedLad, closeLadBanner } = useAbonnementLadBanner(
      ABO_LAD_HOME_COOKIE_NAME
    );
    const {
      showShippingPopin,
      showCountriesListPopin,
      showPlanningPopin,
      showTarifLadPopin,
      showCCPopin,
      showLCPopin,
      deliveryMode,
      communes,
      noCommunes,
      isEligible,
      commune,
      infoMessages,
      alertMessages,
      legalContent,
      isPro,
      displayOrCloseStoreLocatorPopin,
      pushHpProduits,
      showRecettes,
      recettePosition,
      modesCommandeByType,
      classesFlockler,
      abonnementExpireInCurrentMagasin,
      isEasyBox,
      contactsCorapro,
      prospectusShow,
      onProductIntersect,
      toggleCountriesListPopin,
      closeCCPopin,
      closeLCPopin,
      closeTarifLadPopin,
      toggleShippingPopin,
      togglePlanningPopin,
      closePlanningPopin,
      fetchCommunes,
      communeValidated,
      resetCommunes,
      communeSelected,
      resetCommune,
      getDeliveryTermsContent,
      callToActionModeCommandeOverview,
      actionSecondaireModeCommandeOverview,
      getPushProductsFromTransformed,
      getPushListFromTransformed,
      getPushTitleFromTransformed,
      getPushDataFromTransformed,
      mounted,
      HomepageCodes
    } = usePageHome(props, context, deliveryTermsPopin);

    onMounted(mounted);

    return {
      isClosedLad,
      closeLadBanner,
      showShippingPopin,
      showCountriesListPopin,
      showPlanningPopin,
      showTarifLadPopin,
      showCCPopin,
      showLCPopin,
      deliveryMode,
      communes,
      noCommunes,
      isEligible,
      commune,
      infoMessages,
      alertMessages,
      legalContent,
      isPro,
      displayOrCloseStoreLocatorPopin,
      pushHpProduits,
      showRecettes,
      recettePosition,
      modesCommandeByType,
      classesFlockler,
      abonnementExpireInCurrentMagasin,
      isEasyBox,
      contactsCorapro,
      prospectusShow,
      onProductIntersect,
      toggleCountriesListPopin,
      closeCCPopin,
      closeLCPopin,
      closeTarifLadPopin,
      toggleShippingPopin,
      togglePlanningPopin,
      closePlanningPopin,
      fetchCommunes,
      communeValidated,
      resetCommunes,
      communeSelected,
      resetCommune,
      getDeliveryTermsContent,
      callToActionModeCommandeOverview,
      actionSecondaireModeCommandeOverview,
      getPushProductsFromTransformed,
      getPushListFromTransformed,
      getPushTitleFromTransformed,
      getPushDataFromTransformed,
      HomepageCodes,
      illustrationCarotteFromageLait,
      illustrationAnanasPastequePain,
      illustrationAnanasPastequePlat,
      banniereCorapro,
      deliveryTermsPopin
    };
  }
};
</script>

<template>
  <div class="u-bgcolor-white">
    <Popin
      :visible="showTarifLadPopin"
      :page="true"
      :page-back="true"
      aria-label="Tarifs livraison"
      @closed="closeTarifLadPopin"
    >
      <CmsFetcher link="/legal/informations-juridiques/infos-tarifs-livraison" />
    </Popin>
    <Popin
      :page="true"
      :page-back="true"
      :visible="showLCPopin"
      aria-label="Informations livraison collaborative"
      @closed="closeLCPopin"
    >
      <CmsFetcher link="/infos-et-services/sinformer/livraison-collaborative" />
    </Popin>
    <Popin
      :visible="showCCPopin"
      :page="true"
      :page-back="true"
      aria-label="Informations Click & Collect"
      @closed="closeCCPopin"
    >
      <CmsFetcher link="/infos-et-services/sinformer/click-collect" />
    </Popin>
    <Popin
      ref="deliveryTermsPopin"
      aria-label="Termes légaux de la livraison"
      size="sm"
      slide-up
    >
      <PageContenu
        v-if="legalContent"
        :context="'legal'"
        :cms-reponse="legalContent"
      />
    </Popin>

    <Popin
      :visible="showShippingPopin"
      :page="true"
      aria-label="Liste des villes livrées par le magasin"
      :close="toggleShippingPopin"
    >
      <template v-if="showCountriesListPopin && !commune">
        <div class="u-bgcolor-white">
          <!--
            Toujours utiliser cette mise  en forme pour un retour mobile en haut de page
            C'est la même que pour la variante pageBack de popin
          -->
          <div class="u-mb-md">
            <ButtonIcon
              icon-name="arrow-left"
              icon-color="grey-2"
              icon-color-hover="primary-light"
              icon-size="xs"
              link
              class="u-mt-sm u-mb-sm u-ml-xs"
              @click="toggleCountriesListPopin"
            >
              Retour
            </ButtonIcon>
            <Divider />
          </div>

          <div class="u-pl-sm u-pr-sm">
            <h2 class="u-color-primary u-font-secondary u-font-24 u-font-700">
              Liste des villes livrées par le magasin {{ shopName }}
            </h2>
          </div>
          <PlanningCommunesSelector
            v-if="!commune"
            show-filter
            @communeSelected="communeSelected"
          />
        </div>
      </template>
      <template v-else-if="!showCountriesListPopin && !commune">
        <div class="u-bgcolor-white u-viewport-height">
          <!--
            Toujours utiliser cette mise  en forme pour un retour mobile en haut de page
            C'est la même que pour la variante pageBack de popin
          -->
          <div class="u-mb-md">
            <ButtonIcon
              icon-name="arrow-left"
              icon-color="grey-2"
              icon-color-hover="primary-light"
              icon-size="xs"
              link
              class="u-mt-sm u-mb-sm u-ml-xs"
              @click="toggleShippingPopin()"
            >
              Retour
            </ButtonIcon>
            <Divider />
          </div>

          <!-- j'ai utlisé le meme composant desktop pour ne pas dupliquer le code en conditionnant l'affichage de quelque partie selon le layout -->
          <div class="u-pl-sm u-pr-sm">
            <CheckLad
              :communes="communes"
              :is-eligible="isEligible"
              :state="noCommunes ? 'error' : 'success'"
              @toggleCountriesListPopin="toggleCountriesListPopin"
              @codePostalSelected="fetchCommunes"
              @communeValidated="communeValidated"
              @resetCommunes="resetCommunes"
              @communeSelected="communeSelected"
              @getDeliveryTermsContent="getDeliveryTermsContent"
              @togglePlanningPopin="togglePlanningPopin"
            />
          </div>
        </div>
      </template>
      <template v-if="showCountriesListPopin && commune">
        <div class="u-bgcolor-white u-viewport-height">
          <div class="u-mb-md">
            <ButtonIcon
              icon-name="arrow-left"
              icon-color="grey-2"
              icon-color-hover="primary-light"
              icon-size="xs"
              link
              class="u-mt-sm u-mb-sm u-ml-xs"
              @click="resetCommune()"
            >
              Retour
            </ButtonIcon>
          </div>
          <div class="u-pl-sm u-pr-sm">
            <Planning
              :selectable="false"
              :service-id="serviceLadId"
              :code-postal="commune ? commune.attributes.code_postal : null"
              :code-insee="commune ? commune.attributes.code_insee : null"
            />
          </div>
        </div>
      </template>
    </Popin>

    <Popin
      ref="planning"
      :visible="showPlanningPopin"
      :page="true"
      aria-label="Planning"
      :page-back="true"
      @closed="closePlanningPopin"
    >
      <WidgetPlanning
        :commune="commune"
        :type="deliveryMode"
      />
    </Popin>

    <div class="u-py-lg Mob_HP_Slider">
      <div class="c-encart-merch c-encart-merch--slider-hp-mobile">
        <div class="c-encart-merch-item c-encart-merch-item--medium">
          <Carousel
            v-if="
              getPushListFromTransformed(isPro ? HomepageCodes.PRO_MOBILE_HP_SLIDER : HomepageCodes.HP_SLIDER_MOBILE).length > 0
            "
            :key="getPushListFromTransformed(
                isPro ? HomepageCodes.PRO_MOBILE_HP_SLIDER : HomepageCodes.HP_SLIDER_MOBILE
              ).length"
            auto-play
            elements-per-slide="auto"
            navigation-arrows
            loop
            :auto-play-delay="5000"
            :speed="700"
            full-img
            bullets
            pagination-size="md"
            pagination-block
            pagination-position="right"
            navigation-size="sm"
            navigation-icon-color="primary"
            navigation-icon-color-hover="secondary"
            class="c-encart-merch-item__slider"
            variant="hp"
          >
            <CarouselSlide
              v-for="(sliderPush, i) in getPushListFromTransformed(
                isPro ? HomepageCodes.PRO_MOBILE_HP_SLIDER : HomepageCodes.HP_SLIDER_MOBILE
              )"
              :key="`carousel-hp-${i}`"
              :diapo-number="i + 1"
            >
              <HtmlParser
                class="c-carousel__slide-img"
                :promo-printing="true"
                context="HP carousel"
                :push-data="sliderPush"
              />
            </CarouselSlide>
          </Carousel>
        </div>
        <div
          v-if="getPushDataFromTransformed(isPro ? HomepageCodes.PRO_MOBILE_HP_DROITE_SLIDER : HomepageCodes.MOBILE_HP_DROITE_SLIDER).html_content 
            || getPushDataFromTransformed(isPro ? HomepageCodes.PRO_MOBILE_HP_BAS_SLIDER : HomepageCodes.MOBILE_HP_BAS_SLIDER).html_content"
          class="c-encart-merch c-encart-merch--small-column"
        >
          <div
            v-if="getPushDataFromTransformed(isPro ? HomepageCodes.PRO_MOBILE_HP_DROITE_SLIDER : HomepageCodes.MOBILE_HP_DROITE_SLIDER).html_content"
            class="c-encart-merch-item c-encart-merch-item--small"
          >
            <HtmlParser
              class="c-encart-merch-item c-encart-merch-item--small"
              :context="`MOBILE HP DROITE SLIDER : ${getPushTitleFromTransformed(isPro ? HomepageCodes.PRO_MOBILE_HP_DROITE_SLIDER : HomepageCodes.MOBILE_HP_DROITE_SLIDER)} `"
              :promo-printing="true"
              :push-data="getPushDataFromTransformed(isPro ? HomepageCodes.PRO_MOBILE_HP_DROITE_SLIDER : HomepageCodes.MOBILE_HP_DROITE_SLIDER)"
            />
          </div>

          <div
            v-if="getPushDataFromTransformed(isPro ? HomepageCodes.PRO_MOBILE_HP_BAS_SLIDER : HomepageCodes.MOBILE_HP_BAS_SLIDER).html_content"
            class="c-encart-merch-item c-encart-merch-item--small"
          >
            <HtmlParser
              class="c-encart-merch-item c-encart-merch-item--small"
              :context="`MOBILE HP BAS SLIDER : ${getPushTitleFromTransformed(isPro ? HomepageCodes.PRO_MOBILE_HP_BAS_SLIDER : HomepageCodes.MOBILE_HP_BAS_SLIDER)} `"
              :promo-printing="true"
              :push-data="getPushDataFromTransformed(isPro ? HomepageCodes.PRO_MOBILE_HP_BAS_SLIDER : HomepageCodes.MOBILE_HP_BAS_SLIDER)"
            />
          </div>
        </div>
      </div>
    </div>
    <client-only>
      <Container v-if="alertMessages">
        <Alert
          v-if="alertMessages"
          radius="md"
          class="u-mb-sm"
        >
          <p class="u-color-secondary">
            {{ uppercaseFirstLetter(alertMessages) }}
          </p>
        </Alert>
      </Container>
      <Container v-if="infoMessages">
        <Alert
          radius="md"
          class="u-mb-sm"
        >
          <p class="u-color-primary">
            {{ uppercaseFirstLetter(infoMessages) }}
          </p>
        </Alert>
      </Container>
    </client-only>
    <HtmlParser
      v-if="!isPro && getPushDataFromTransformed(HomepageCodes.HP_BANDEAU_FULL).html_content"
      :context="`HP BANDEAU FULL : ${getPushTitleFromTransformed(HomepageCodes.HP_BANDEAU_FULL)}`"
      :promo-printing="true"
      :push-data="getPushDataFromTransformed(HomepageCodes.HP_BANDEAU_FULL)"
    />
    <div
      v-if="!isPro"
      class="u-bgcolor-bg u-pt-md u-pb-sm Mob_HP_Livraison_1"
    >
      <client-only v-if="!userId">
        <HomeAchatExpressMobile />
      </client-only>
      <HomeAchatExpressMobile v-else />
      <template v-if="!isNational">
        <h2 class="u-font-secondary u-color-primary u-font-26 u-text-center u-mt-lg">
          Vos courses où vous voulez
        </h2>
        <div class="u-p-sm">
          <Card
            radius="md"
            border-color="border"
            class="u-p-xs"
          >
            <template
              v-for="(typeMdc, index) in cardsModesCommandeMiseEnAvant"
              :key="typeMdc"
            >
              <template v-if="typeMdc !=='PRC' ? modesCommandeByType[typeMdc] : isEasyBox">
                <Divider
                  v-if="index > 0"
                  dotted
                  size="sm"
                />
                <ModeCommandeOverview
                  :mode-commande="modesCommandeByType[typeMdc]"
                  @callToAction="callToActionModeCommandeOverview"
                  @actionSecondaire="actionSecondaireModeCommandeOverview"
                />
              </template>
            </template>
          </Card>
        </div>
      </template>
      <template v-else>
        <Container>
          <Card
            radius="lg"
            border-size="1"
            border-color="border"
            class="u-p-sm u-mt-sm"
          >
            <StoreAttachment
              is-national
              :shopfirst-slot-available="shopfirstSlotAvailable"
              @togglePlanningPopin="togglePlanningPopin"
              @displayOrCloseStoreLocatorPopin="
                $emit('displayOrCloseStoreLocatorPopin')
              "
            />
          </Card>
        </Container>
      </template>
    </div>
    <div
      v-if="showAboLad && !isClosedLad"
      class="u-px-sm u-pt-sm Mob_HP_Livraison_2"
    >
      <Container>
        <AbonnementRenouvellement
          v-if="abonnementExpireInCurrentMagasin"
          class="u-mt-sm"
          @close="closeLadBanner"
        />
        <AbonnementLadBanniere
          v-else
          class="u-mt-sm"
          @close="closeLadBanner"
        />
      </Container>
    </div>
    <div
      v-if="pushHpProduits && pushHpProduits.length > 0"
      class="u-bgcolor-bg Mob_HP_Produits"
    >
      <h2
        id="pushHpProduits"
        class="u-bgcolor-white u-font-secondary u-color-primary u-font-32 u-font-700 u-text-center u-mt-lg u-pb-md"
      >
        {{ getPushTitleFromTransformed(isPro ? HomepageCodes.PRO_HP_PRODUITS : HomepageCodes.HP_PRODUITS) }}
      </h2>
      <div class="u-bgcolor-white u-px-xs u-pb-md">
        <PushProductBlock
          :label="trackingCodes.LABELGA.HP"
          :push-title="getPushTitleFromTransformed(isPro ? HomepageCodes.PRO_HP_PRODUITS : HomepageCodes.HP_PRODUITS)"
          :products="pushHpProduits"
          :recette-index="showRecettes ? recettePosition : -1"
          :is-national="isNational"
          aria-labelledby="pushHpProduits"
          @onProductIntersect="
            (i) => onProductIntersect(i, isPro ? HomepageCodes.PRO_HP_PRODUITS : HomepageCodes.HP_PRODUITS, 1)
          "
        />
      </div>
    </div>
    <div
      v-if="isPro"
      class="u-pt-lg"
    >
      <h2 class="u-font-secondary u-color-primary u-font-32 u-text-center u-mb-md">
        Votre contact Services pro
      </h2>
      <div class="u-flex u-flex-justify-center u-flex-align-center">
        <ContactInfoCorapro
          v-if="contactsCorapro"
          class="c-home-contact-infos-corapro-mobile"
          is-home-page
          :contact="contactsCorapro"
        />
      </div>
    </div>
    <div
      v-if="isPro"
      class="u-py-md u-px-sm u-full-width u-inline-flex u-flex-justify-center"
    >
      <LinkTo
        class="c-home-bandeau-corapro-mobile"
        to="infos-et-services/aide/contactez-nous/formulaire-cora-pro"
      >
        <LazyImage :src="banniereCorapro" />
      </LinkTo>
    </div>
    <NuxtLazyHydrate
      v-if="prospectusShow && !isPro"
      when-visible
    >
      <div class="u-bgcolor-bg u-pb-xlg Mob_HP_Prospectus">
        <Container>
          <Card
            radius="lg"
            border-size="1"
            border-color="border"
            class="u-p-md u-text-center"
          >
            <Titre
              size="md"
              weight="md"
              tag="p"
              variant="primary"
              class="u-mb-md"
            >
              Faites des économies en consultant les prospectus
            </Titre>
            <GridRow class="u-mb-md">
              <template
                v-for="item in prospectus.slice(0, 2)"
                :key="item.id"
              >
                <GridCol class="u-text-center">
                  <div class="u-flex u-flex-justify-center u-full-height">
                    <Prospectus
                      :img-path="item.attributes.cover"
                      :period="item.attributes.period"
                      :title="item.attributes.title"
                      :link="item.attributes.url"
                      :start-date="item.attributes.start_at"
                      :page-type="trackingCodes.PAGETYPE.homepage"
                      img-width="200"
                      light
                    />
                  </div>
                </GridCol>
              </template>
            </GridRow>
            <Button
              variant="secondary"
              radius="full"
              size="md"
              to="/prospectus"
            >
              Voir tous les prospectus
            </Button>
          </Card>
        </Container>
      </div>
    </NuxtLazyHydrate>
    <template v-if="!isPro">
      <ContainerHeading
        v-if="
          getPushDataFromTransformed(HomepageCodes.MOBILE_HP_BOUTIQUE_MEA_1)
            .html_content ||
            getPushDataFromTransformed(HomepageCodes.MOBILE_HP_BOUTIQUE_MEA_2)
              .html_content
        "
        :img-path="illustrationCarotteFromageLait"
        content-padding-custom="u-pb-none"
        class="Mob_HP_Merch_Bas_1"
      >
        <h2
          v-if="
            getPushTitleFromTransformed(HomepageCodes.MOBILE_HP_BOUTIQUE_MEA_1)
          "
          class="u-font-secondary u-color-primary u-font-32 u-font-26@md u-font-700 u-text-center u-mb-md"
        >
          {{
            getPushTitleFromTransformed(HomepageCodes.MOBILE_HP_BOUTIQUE_MEA_1)
          }}
        </h2>
        <GridRow>
          <GridCol
            v-if="
              getPushDataFromTransformed(HomepageCodes.MOBILE_HP_BOUTIQUE_MEA_1)
                .html_content
            "
            sm="12"
            class="u-mb-md@sm"
          >
            <Card class="u-bgcolor-white u-p-sm u-text-center">
              <HtmlParser
                :promo-printing="true"
                :context="
                  `HP MEA 1: ${getPushTitleFromTransformed(
                    HomepageCodes.MOBILE_HP_BOUTIQUE_MEA_1
                  )}`
                "
                class="u-inline-block"
                :push-data="
                  getPushDataFromTransformed(
                    HomepageCodes.MOBILE_HP_BOUTIQUE_MEA_1
                  )
                "
              />
            </Card>
          </GridCol>
          <GridCol
            v-if="
              getPushDataFromTransformed(HomepageCodes.MOBILE_HP_BOUTIQUE_MEA_2)
                .html_content
            "
            sm="12"
          >
            <Card class="u-bgcolor-white u-p-sm u-text-center">
              <HtmlParser
                :context="
                  `HP MEA 2: ${getPushTitleFromTransformed(
                    HomepageCodes.MOBILE_HP_BOUTIQUE_MEA_1
                  )}`
                "
                :promo-printing="true"
                class="u-inline-block"
                :push-data="
                  getPushDataFromTransformed(
                    HomepageCodes.MOBILE_HP_BOUTIQUE_MEA_2
                  )
                "
              />
            </Card>
          </GridCol>
        </GridRow>
      </ContainerHeading>
      <ContainerHeading
        v-if="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT).html_content || getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT_2).html_content"
        :img-path="illustrationAnanasPastequePain"
        dotted
        class="Mob_HP_Merch_Bas_2"
      >
        <h2 class="u-font-secondary u-color-primary u-font-32 u-font-700 u-text-center u-mb-md">
          {{ getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT).html_content ? getPushTitleFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT) : getPushTitleFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT_2) }}
        </h2>
        <div
          v-if="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT)"
          :class="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT_2).html_content ? 'u-mb-sm' : ''"
        >
          <div class="c-encart-merch">
            <HtmlParser
              v-if="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT).html_content"
              class="c-encart-merch-item c-encart-merch-item--medium"
              :context="`MOBILE HP BAS SLIDER : ${getPushTitleFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT)} `"
              :promo-printing="true"
              :push-data="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT)"
            />
            <HtmlParser
              v-if="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT, 2).html_content"
              class="c-encart-merch-item c-encart-merch-item--medium"
              :context="`MOBILE HP BAS SLIDER : ${getPushTitleFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT, 2)} `"
              :promo-printing="true"
              :push-data="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT, 2)"
            />
            <HtmlParser
              v-if="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT, 3).html_content"
              class="c-encart-merch-item c-encart-merch-item--medium"
              :context="`MOBILE HP BAS SLIDER : ${getPushTitleFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT, 3)} `"
              :promo-printing="true"
              :push-data="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT, 3)"
            />
          </div>
        </div>
        <HtmlParser
          v-if="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT_2).html_content"
          class="c-encart-merch"
          :context="`MOBILE HP MEA HAUT 2 : ${getPushTitleFromTransformed(HomepageCodes.HP_MEA_HAUT_2)} `"
          promo-printing
          :push-data="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_HAUT_2)"
        />
      </ContainerHeading>
      <ContainerHeading
        v-if="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_BAS).html_content"
        :img-path="illustrationAnanasPastequePlat"
        dotted
        class="Mob_HP_Merch_Bas_3"
      >
        <h2
          v-if="
            getPushTitleFromTransformed(HomepageCodes.MOBILE_HP_MEA_BAS)
          "
          class="u-font-secondary u-color-primary u-font-32 u-font-26@md u-font-700 u-text-center u-mb-md"
        >
          {{
            getPushTitleFromTransformed(HomepageCodes.MOBILE_HP_MEA_BAS)
          }}
        </h2>
        <div :class="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_BAS, 2).html_content ? 'u-mb-sm' : ''">
          <HtmlParser
            v-if="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_BAS)"
            class="c-encart-merch"
            :context="
              `HP MEA BAS : ${getPushTitleFromTransformed(
                HomepageCodes.MOBILE_HP_MEA_BAS,
              )} `
            "
            promo-printing
            :push-data="
              getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_BAS)
            "
          />
        </div>
        <HtmlParser
          v-if="getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_BAS, 2).html_content"
          class="c-encart-merch"
          :context="
            `HP MEA BAS : ${getPushTitleFromTransformed(HomepageCodes.MOBILE_HP_MEA_BAS, 2)} `
          "
          promo-printing
          :push-data="
            getPushDataFromTransformed(HomepageCodes.MOBILE_HP_MEA_BAS, 2)
          "
        />
      </ContainerHeading>
    </template>
  </div>
</template>
<style lang="scss">
@import "@/assets/styles/components/encart-merch.scss";
.c-home-bandeau-corapro-mobile {
  display: inline-flex;
  max-width: 47.2rem;
  min-width: 30.4rem;
  width: 100%;
  height: 16rem;
  border-radius: 1.2rem;
  overflow: hidden;

  picture {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: none;
      margin-bottom: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@/assets/styles/components/check-lad-mobile.scss";
.c-home-contact-infos-corapro-mobile {
  margin: 0 !important;
  border-radius: radius(md);
  border: 2px solid color(primary-light);
  padding: spacing(sm);
}
</style>
